<template>
<div>
  <el-menu :default-openeds="openeds" style="width: 17%;position: fixed;top: 0;left: 0;padding: 70px 30px 70px 1px;height: 100%;" 
default-active="2"
class="el-menu-vertical-demo"

background-color="#545c64"
text-color="#fff"
active-text-color="#ffd04b">
    <div >
      <el-submenu index="1">
        <template slot="title">
          <!-- <i class="el-icon-location"></i> -->
          <span style="font-size: 25px;">用户足迹</span>
        </template>
        <el-menu-item class="menuit" style="margin-left: 30px;font-size: 25px;padding: 10px;height: 50px;" :style="showType==1?'color: yellow;':''" @click="changeShow('1')">落地页</el-menu-item>
      </el-submenu>
      <div style="height: 10px;"></div>
      <el-submenu index="2">
        <template slot="title">
          <!-- <i class="el-icon-location"></i> -->
          <span style="font-size: 25px;">用户订单</span>
        </template>
        <el-menu-item style="margin-left: 30px;font-size: 25px;padding: 10px;height: 50px;" :style="showType==2?'color: yellow;':''" @click="changeShow('2')">已提交</el-menu-item>
        <el-menu-item style="margin-left: 30px;font-size: 25px;padding: 10px;height: 50px;" :style="showType==3?'color: yellow;':''" @click="changeShow('3')">已支付</el-menu-item>
      </el-submenu>
    </div>
  </el-menu>




  <block v-if="showType==1">
  <el-table size="8" style="width: 80%;left:20%;top:50px" :data="footList" height="600px" header-row-class-name="header_row_className" ref="multipleTable" row-key="getRowKeys"  highlight-current-row element-loading-text="拼命加载中">
    <el-table-column 
      prop="createTime"
      label="访问时间">
    </el-table-column>
    <el-table-column 
      prop="outTime"
      label="离开时间">
    </el-table-column>
    <el-table-column 
      prop="ip"
      label="ip">
    </el-table-column>
    <el-table-column 
      prop="ipAddress"
      label="地域">
    </el-table-column>
    <el-table-column 
      prop="fullPath"
      label="访问链接">
    </el-table-column>
  
  </el-table>
  <el-pagination style="width: 80%;left:20%;margin-top: 20px;"
    :current-page="currentPage"
    @current-change="handleCurrentChange"
    :page-size="pageSize" />
  </block>
  <block v-if="showType==2">
  <el-table size="8" style="width: 80%;left:20%;top:50px" :data="noBuyList" height="600px" header-row-class-name="header_row_className" ref="multipleTable" row-key="getRowKeys"  highlight-current-row element-loading-text="拼命加载中">
    <el-table-column 
      prop="createTime"
      label="创建时间">
    </el-table-column>
    <el-table-column 
      prop="prodName"
      label="产品名称">
    </el-table-column>
    <el-table-column 
      prop="orderNumber"
      label="订单号">
    </el-table-column>
    <el-table-column 
      prop="total"
      label="价格">
    </el-table-column>
    <el-table-column 
      prop="userName"
      label="用户姓名">
    </el-table-column>
    <el-table-column 
      prop="userPhone"
      label="手机号">
    </el-table-column>
  </el-table>
  <el-pagination style="width: 80%;left:20%;margin-top: 20px;"
    :current-page="currentPage"
    @current-change="handleNoPayCurrentChange"
    :page-size="pageSize" />
  </block>
  <block v-if="showType==3">
  <el-table size="8" style="width: 80%;left:20%;top:50px" :data="buyList" height="600px" header-row-class-name="header_row_className" ref="multipleTable" row-key="getRowKeys"  highlight-current-row element-loading-text="拼命加载中">
    <el-table-column 
      prop="createTime"
      label="创建时间">
    </el-table-column>
    <el-table-column 
      prop="payTime"
      label="支付时间">
    </el-table-column>
    <el-table-column 
      prop="prodName"
      label="产品名称">
    </el-table-column>
    <el-table-column 
      prop="orderNumber"
      label="订单号">
    </el-table-column>
    <el-table-column 
      prop="total"
      label="价格">
    </el-table-column>
    <el-table-column 
      prop="userName"
      label="用户姓名">
    </el-table-column>
    <el-table-column 
      prop="userPhone"
      label="手机号">
    </el-table-column>
  </el-table>
  <el-pagination style="width: 80%;left:20%;margin-top: 20px;"
    :current-page="currentPage"
    @current-change="handlePayCurrentChange"
    :page-size="pageSize" />
  </block>
</div>
</template>
<script>
var _hmt = _hmt || [];
import wx from 'weixin-js-sdk'
import vueSeamlessScroll from 'vue-seamless-scroll'
import QRCode from 'qrcode'
import axios360 from 'axios'
import md5 from 'js-md5';

export default {
  
  name: 'yx',
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      footList:[],
      buyList: [],
      noBuyList: [],
      currentPage: 1,
      currentPay: 1,
      currentNoPay: 1,
      pageSize: 10,
      header_row_className: ['11','22'],
      openeds: ['1','2'],
      showType: 1
    }
  },
  computed: {
    optionHover () {
      return {
        hoverStop: false, //是否开启鼠标悬停stop
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    const thisObj = this
    thisObj.onLoad()


  },
  methods: {
    onLoad: function () {
      this.getFootList()
      
    },
    toBaidu() {

    },
    handleSizeChange (size) {
        console.log(size,'size');
      this.pagesize = size;
      console.log(this.pagesize); //每页下拉显示数据
    },
    handleCurrentChange (currentPage) {
        // console.log(currentPage,'currentPage');
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
      this.getFootList()
    },
    handlePayCurrentChange (currentPage) {
        // console.log(currentPage,'currentPage');
      this.currentPay = currentPage;
      console.log(this.currentPay); //点击第几页
      this.getBuyList()
    },
    handleNoPayCurrentChange (currentPage) {
        // console.log(currentPage,'currentPage');
      this.currentNoPay = currentPage;
      console.log(this.currentNoPay); //点击第几页
      this.getNoBuyList()
    },
    getFootList() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/getAllFoot?size=15&current='+ thisObj.currentPage, {}).then(res => {
        // console.log(res)
        thisObj.footList = res.records
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    getBuyList() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/order/getPay?size=15&current='+ thisObj.currentPay, {}).then(res => {
        // console.log(res)total
        var buyList = res.records
        for (const i in buyList) {
          buyList[i].total = buyList[i].total/100
        }
        thisObj.buyList = buyList
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    getNoBuyList() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/order/getNoPay?size=15&current='+ thisObj.currentNoPay, {}).then(res => {
        // console.log(res)
        var noBuyList = res.records
        for (const i in noBuyList) {
          noBuyList[i].total = noBuyList[i].total/100
        }
        thisObj.noBuyList = noBuyList
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    changeShow(e) {
      if (e=='1') {
        this.currentPage = 1
        this.getFootList()
      } else if(e=='2') {
        this.currentNoPay = 1
        this.getNoBuyList()
      } else if(e=='3') {
        this.currentPay = 1
        this.getBuyList()
      }
      this.showType = e
    },
    // 页面跳转/admin/order
    pageJump (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes
      
    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    thisObj.userPhone = ''
      let queryData = {
        goodsName: info.goodsName,
        title: goodsAttributes[obj].title,
        values: goodsAttributes[obj].values[index],
        valueKey: goodsAttributes[obj].valueKey[index],
        price: info.groupBuyingPrice,
        oldPrice: info.buyPrice,
        wxCode: that.wxCode,
        getId: that.getId,
        introduceImg: goodsAttributes[obj].imgValue[index]
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    pageJumpShop (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes

    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    // thisObj.userPhone = ''
      let queryData = {
        goodsId: info.id,
        lon: that.lon,
        lat: that.lat,
      }
      thisObj.$router.push({
        path: '/yxShop',
        query: queryData
      })
    },
    onClickLeft () {
      this.pageNo = 0
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri, 
        query: queryData
      })
    },
    setBuyList() {
      this.buyList= [{name:'王*',time:1},{name:'张*里',time:1},{name:'王*和',time:2},
      {name:'李*',time:3},{name:'赵*极',time:3},{name:'王*',time:3},{name:'张*',time:4},
      {name:'沈*',time:5},{name:'刘*',time:10},{name:'李*芝',time:10},{name:'赵*',time:11}]
    },
    /**
   * 定时器，计算剩下时间
   * @param {*} end_time 
   */
  getLeftTime(end_time) {
    let left_time = this.getTimestap(end_time);
    this.initDate(left_time)
    this.timer = setInterval(() => {
      if (left_time-- === 0) {
        this.left_time = 0
        this.left_time_list = this.formatSeconds(0)
        clearInterval(this.timer)
      } else {
        this.initDate(left_time)
      }
    }, 1000);
  },  
  /**
  * 初始化数据
    */
  initDate(e) {
    var that = this
    that.left_time_list = that.formatSeconds(e),
    that.left_time_list_date = that.formatDate(JSON.stringify(that.left_time_list));
    that.left_time = e
  },
  /**
    * 获取指定时间-当前时间的秒数
    * @param {*} end_time 
    */
  getTimestap(end_time) {
    // 当前时间
    var currentTime = parseInt(new Date().getTime() / 1000);
    // 未来时间
    var futureTime = parseInt(new Date(end_time.replace(/-/g, '/')).getTime() / 1000); //ios无法解析
    return futureTime <= currentTime ? 0 : futureTime - currentTime;
  },/**
  * 毫秒-天-时-分-秒
  * @param {*} value 
  */
  formatSeconds(value) {
    let time = [],
      day = parseInt(value / 86400),
      hour = parseInt((value % 86400) / 3600),
      min = parseInt(((value % 86400) % 3600) / 60),
      sec = parseInt(((value % 86400) % 3600) % 60);
    time[0] = day > 0 ? this.addZero(day) : this.addZero(0);
    time[1] = hour > 0 ? this.addZero(hour) : this.addZero(0);
    time[2] = min > 0 ? this.addZero(min) : this.addZero(0);
    time[3] = sec > 0 ? this.addZero(sec) : this.addZero(0);
    return time;
  },
  /**
   * 拆分数组-天-时-分-秒
   * @param {*} e 
   */
  formatDate(e) {
    let list = JSON.parse(e);
    for (let i = 0; i < list.length; i++) {
      list[i] = list[i].toString().split('');
    }
    return list;
  },
  /**
   * 补0
   * @param {*} num 
   */
  addZero(num) {
    return num < 10 ? "0" + num : num;
  },
    
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl {
    font-size: 36px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.an_shop {
  width: 100%;
  line-height: 130px;
  color: #fff;
  background-color: #ec3636;
  border-radius: 30px;
  text-align: center;
  font-size: 48px;
  height: 130px;
}
.onno {
  font-size: 40px;
  border-radius: 30px;
}

.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #f53434;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #f53434;
}
.bg-redler {
    background-color: #ffc0c0;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 10px;
}
.padding-top-sm {
    padding-top: 20px;
}

.cu-modal.show {
    opacity: 1;
    transition-duration: 0.3s;
    -ms-transform: scale(1);
    transform: scale(1);
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: auto;
}
.cu-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1110;
    opacity: 0;
    outline: 0;
    text-align: center;
    -ms-transform: scale(1.185);
    transform: scale(1.185);
    backface-visibility: hidden;
    perspective: 2000px;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease-in-out 0s;
    pointer-events: none;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.cu-modal.bottom-modal::before {
    vertical-align: bottom;
}
.cu-modal::before {
    content: "\200B";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}
.cu-modal.bottom-modal .cu-dialog {
    width: 100%;
    border-radius: 0;
}
.cu-dialog {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: auto;
    margin-right: auto;
    width: 680px;
    max-width: 100%;
    background-color: #f8f8f8;
    border-radius: 10px;
    overflow: hidden;
}
.text-right {
    text-align: right;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.cuIcon-close:before {
    content: "\e646";
}
.text-black, .line-black, .lines-black {
    color: #333333;
}
.text-bold {
    font-weight: bold;
}
.text-center {
    text-align: center;
}
.text-xl {
    font-size: 36px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.padding-lr-sm {
    padding-left: 20px;
    padding-right: 20px;
}
.round {
    border-radius: 500px;
}





button.tools-item {
  line-height: 1.1;
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 24px;
  color: #fff;
  position: fixed;
  bottom: 140px;
  right: 55px;
}

 .tools-item cover-view {
  display: flex;
  align-items: center;
}
 .tools-item cover-image {
  width: 40px;
  margin: 0 12px 0 40px;
}
.kqb-share2 {
  opacity: 0.3;
  width: 100%;
  height: 100%;
  background-color: #333;
  position: fixed;
  bottom: 0px;
}
.bgC-white {
  background-color: #fff;
}
[class*="cuIcon1-"] {
  font-family: "myFont";
  font-size: inherit;
  font-style: normal;
}
.daoh {
  height: 50px;
  width: 50px;
  margin-left: 40px;
}
.shop-img {
  width: 140px;
  height: 140px;
  border-radius: 20px;
  margin: 0 10px 0 15px;
}
.cuIcon-locationfill:before {
    content: "\e650";
    font-size: inherit;
    font-style: normal;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.co {
    color: #7eb0f7;
}
.text-gray, .line-gray, .lines-gray {
    color: #aaaaaa;
}
.swiper-img {
  width: 100%;
  height: 550px;
  border-radius:10px;
}




.bannerswipers {
  width: 100% !important;
  height: 500px;
  overflow: hidden;
}

.bannerswipers image {
  display: block;
}

/*用来包裹所有的小圆点  */

.bannerdots {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

/*未选中时的小圆点样式 */

.bannerdot {
  width: 16px;
  height: 16px;
  margin-right: 26px;
  background-color: #d1d1ce;
  border-radius: 16px;
}

.lunbo {
  height: 520px;
}
image {
 width: 100%;
 height: 500px;
  display: inline-block;
  position: relative;
  z-index: 0;
}
.touxiang{
  width: 80px;
  height: 80px;
}

.cu-item {
  text-align: center;
  display: inline-block;
  min-width: 160px !important;
  color: #999999;
  /* display: flex !important; */
  align-items: center !important;
  justify-content: center !important;
  font-size: 31px;
  font-weight: bolder;
}
/* 弹幕 */

.item-ranking {
  margin: 0 30px 30px 30px;
  border-radius: 30px;
}

.paihangimg {
  height: 60px;
  width: 60px;
  border-radius: 500px;
  margin: 0 10px 0 0;
  background-color: #4ecde4;
}

/* 划线价格 */
.huaxianjia {
  color: #ffffff;
  font-size: 24px;
  padding-top: 58px;
  text-decoration: line-through;
}

.xuanfu-tvimg {
  width: 130px;
  height: 125px;
  position: fixed;
  bottom: 460px;
  z-index: 3;
  right: 35px;
}

.on2::after {
  text-align: center;
  width: 170px;
  height: 8px;
  background-color: #3ea4f8;
  border-radius: 4px;
  content: "";
  position: absolute;
  top: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  opacity: 0.8;
  /* border-bottom: 2px solid #405cfd !important; */
}

.on {
  color: #000;
  font-size: 40px;

}
.time-box {
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  padding: 10px 5px;
  /* background: #fff; */
}

.time-item {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  margin: 0 2px;
  background: #f7f5b4;
  color: #e70f0f;
}

.time-item1 {
  width: 30px;
  height: 40px;
  background: linear-gradient(90deg, #FFEBB1 0%, #FFDB8F 100%);
  border-radius: 4px;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  margin: 0 10px;
}
.bg-red {
    background-color: #e54d42;
    color: #ffffff;
}
.padding-lr-xs {
    padding-left: 12px;
    padding-right: 12px;
}

.justify-between {
    justify-content: space-between;
}

.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.padding-tb-xs {
    padding-top: 12px;
    padding-bottom: 12px;
}
.text-df {
	font-size: 20px;
}
.padding-tb-sm {
	padding-top: 20px;
	padding-bottom: 20px;
}

.padding-tb {
	padding-top: 30px;
	padding-bottom: 30px;
}
.padding-lr {
	padding-left: 30px;
	padding-right: 30px;
}
.seamless-warp {
  height: 550px;
  overflow: hidden;
}
.zhuanshu {
    background-color: #f85959;
    padding: 7px 10px;
    border-radius: 35px;
    letter-spacing: 2px;
}
.text-white, .line-white, .lines-white {
    color: #ffffff;
}
.comp {
  font-size: 30px;
  margin: 20px 20px;
  align-items:center;
}

.dbg {
  background: url(/img/bg.jpg);
}
.el-table .cell {
  text-align: center;
}
</style>
